import useNetwork from '@/hooks/useNetwork';
import { project_networkId } from '@/utils/query-helpers';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    ...project_networkId(network)
  };
};
